export const TEXT_LENGTH = '65535';

export enum SORT_ORDER {
  NONE = '',
  ASC = 'asc',
  DESC = 'desc'
}
